// Comprimă/redimensionează o poză direct în browser (telefon) înainte de upload.
// Reduce o poză de 5–12 MB la ~300 KB, păstrând orientarea corectă (EXIF).
// La orice eroare întoarce fișierul original, ca să nu blocheze încărcarea.
export async function compressImage(file, { maxSide = 1600, quality = 0.75 } = {}) {
  if (!file || !file.type || !file.type.startsWith('image/')) return file;
  try {
    let bitmap;
    try {
      bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
    } catch {
      bitmap = await createImageBitmap(file);
    }
    const { width, height } = bitmap;
    const scale = Math.min(1, maxSide / Math.max(width, height));
    const w = Math.max(1, Math.round(width * scale));
    const h = Math.max(1, Math.round(height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(bitmap, 0, 0, w, h);
    if (bitmap.close) bitmap.close();
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
    if (!blob || blob.size >= file.size) return file; // nu înrăutăți fișiere deja mici
    const name = (file.name || 'poza').replace(/\.[^.]+$/, '') + '.jpg';
    return new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() });
  } catch {
    return file;
  }
}
